type ValidatePasswordRet = {
  valid: boolean;
  message: string;
};

export default function validatePassword(password: string): ValidatePasswordRet {
  if (password.length < 8) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir 8 caractères minimum",
    };
  }

  const hasUpperCase = /[A-Z]/.test(password);
  if (!hasUpperCase) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir minimum 1 majuscule",
    };
  }

  const hasLowerCase = /[a-z]/.test(password);
  if (!hasLowerCase) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir minimum 1 minuscule",
    };
  }

  const hasNumber = /\d/.test(password);
  if (!hasNumber) {
    return {
      valid: false,
      message: "Le mot de passe doit contenir minimum 1 chiffre",
    };
  }

  // const hasSymbol = /[^\w\s]|_/.test(password);
  // if (!hasSymbol) {
  //   return {
  //     valid: false,
  //     message: "Le mot de passe doit contenir minimum 1 caractère spécial",
  //   };
  // }

  return { valid: true, message: "Ok" };
}

export function validatePasswordAtOnce(password: string): ValidatePasswordRet {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  if (!regex.test(password)) {
    return {
      valid: false,
      message:
        "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial",
    };
  }
  return { valid: true, message: "Ok" };
}
